import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import styled from 'styled-components';
import { TableCellMixin } from '../../mixins/components/TableCellMixin';
export var StyledTableCell = /*#__PURE__*/styled.td.withConfig({
  displayName: "StyledTableCell",
  componentId: "c11n-8-64-0__sc-1mvjdio-0"
})(["", ""], TableCellMixin);
/**
 * TableCell
 *
 * @since 8.0.0
 */

var TableCell = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(StyledTableCell, _extends({
    ref: ref
  }, props));
});
TableCell.displayName = 'Table.Cell';
/** @component */

export default TableCell;